import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import {
  Button,
  Form,
  FormFeedback,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from "reactstrap";

import { LoadingSpinner } from "../../../constants/const";
import { GetLanguageString } from "../../helper/Components";
import { ApiEducation } from "./ApiEducation";
import Draggable from "react-draggable";
import swal from "sweetalert";
import { GetSelectedLanguage } from "../../helper/Method";
import Select from "react-select";

const AddDegreeCertificate = ({ setEducationDegreeAddModal, reload, setReload }) => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [educationType, setEducationType] = useState([]);
  const [educationFields, setEducationFields] = useState([]);
  const [degreeValues, setDegreeValues] = useState({
    degree: "",
    educationTypeId: "",
    educationFieldsId: []
  });
  const [errors, setErrors] = useState(degreeValues);
  const toggle = () => setEducationDegreeAddModal(false);
  const [position, setPosition] = useState({ x: 0, y: 0 });

  const handleDrag = (e, ui) => {
    const { x, y } = position;
    setPosition({ x: x + ui.deltaX, y: y + ui.deltaY });
  };

  const validate = () => {
    let temp = {};
    temp.degree = degreeValues.degree
      ? ""
      : t("education_degree_name_err");
    temp.educationTypeId = degreeValues.educationTypeId !== "" && degreeValues.educationTypeId !== null
      ? ""
      : t("education_degree_type_err");
    temp.educationFields = degreeValues.educationFieldsId.length > 0
      ? ""
      : t("education_degree_fields_err");

    setErrors({
      ...temp,
    });

    return Object.values(temp).every((x) => x === "");
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setDegreeValues({
      ...degreeValues,
      [name]: value,
    });
  };

  const handleSelectEducationType = (record) => {
    setErrors({
      ...errors,
      educationTypeId: "",
    });
    setDegreeValues({
      ...degreeValues,
      educationTypeId: record.value,
    });
  };

  const handleSelectEducationFields = (record) => {
    setErrors({
      ...errors,
      educationFields: "",
    });
    let educationFieldIds = [];

    // eslint-disable-next-line
    record.map((obj) => {
      educationFieldIds.push(obj.value);
    });

    if (educationFieldIds.length > 0) {
      setDegreeValues({
        ...degreeValues,
        educationFieldsId: educationFieldIds,
      });
    }
  };

  useEffect(() => {
    ApiEducation()
      .getEducationType()
      .then((res) => {
        setEducationType(res.data);
      })
      .catch((err) => {
        console.log(err);
      });

      ApiEducation()
        .getEducationFields()
        .then((res) => {
          setEducationFields(res.data);
        })
        .catch((err) => {
          console.log(err);
        });
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validate()) {
      setLoading(true);
      setReload(!reload);
      setEducationDegreeAddModal(false);
      ApiEducation()
        .addDegree(degreeValues)
        .then((res) => {
          toggle();
          setLoading(false);
          swal({
            title: t("education_add_degree_success"),
            className: GetSelectedLanguage() === "en" ? "" : "ur",
            icon: "success",
            buttons: "OK",
          });
        })
        .catch((err) => {
          console.log(err);
          setLoading(false);
          setReload(!reload);
          swal({
            title: "Error: " + err.response?.data || err,
            icon: "error",
            buttons: "OK",
          });
        });
    }
  };

  return (
    <div>
      <Draggable position={position} onDrag={handleDrag} cancel=".no-drag">
        <Modal isOpen={true} className="inmodal" autoFocus={false}>
          <ModalHeader className="modal-title" tag="h4">
            {<GetLanguageString props="education_add_degree" />}
          </ModalHeader>
          {!loading ? (
            <Form onSubmit={handleSubmit}>
              <ModalBody>
              <FormGroup>
                  <Label>
                    {
                      <GetLanguageString props="education_add_degree_name" />
                    }
                  </Label>
                  <Input
                    autoFocus
                    type="text"
                    name="degree"
                    className="no-drag"
                    value={degreeValues.degree}
                    onChange={handleInputChange}
                    {...(errors.degree && { invalid: true })}
                  />
                  {errors.degree && (
                    <FormFeedback>
                      <h4>{errors.degree}</h4>
                    </FormFeedback>
                  )}
                </FormGroup>
                <FormGroup>
                  <Label className="col-form-label">
                    {
                      <GetLanguageString props="education_add_degree_type" />
                    }
                  </Label>
                  <Select
                    options={educationType}
                    className="basic-select ur no-drag"
                    classNamePrefix="select"
                    onChange={handleSelectEducationType}
                    {...(errors.educationTypeId && { invalid: true })}
                  />
                  {errors.educationTypeId && (
                    <h4 className="text-error">{errors.educationTypeId}</h4>
                  )}
                </FormGroup>
                <FormGroup>
                  <Label className="col-form-label">
                    {
                      <GetLanguageString props="education_add_degree_fields" />
                    }
                  </Label>
                  <Select
                    options={educationFields}
                    className="basic-multi-select ur no-drag"
                    classNamePrefix="select"
                    isMulti
                    onChange={handleSelectEducationFields}
                    {...(errors.educationFields && { invalid: true })}
                  />
                  {errors.educationFields && (
                    <h4 className="text-error">{errors.educationFields}</h4>
                  )}
                </FormGroup>
              </ModalBody>
              <ModalFooter>
                <Button color="white" onClick={toggle}>
                  {<GetLanguageString props="common_cancel" />}
                </Button>
                <Button color="primary" type="submit">
                  {<GetLanguageString props="common_save_changes" />}
                </Button>
              </ModalFooter>
            </Form>
          ) : (
            LoadingSpinner()
          )}
        </Modal>
      </Draggable>
    </div>
  );
};

export default AddDegreeCertificate;
